// extracted by mini-css-extract-plugin
export default {"notice":"DemoArtistNotice_notice__uCgzg","text":"DemoArtistNotice_text__v7tK8","action":"DemoArtistNotice_action__IJ71G","dismiss":"DemoArtistNotice_dismiss__fFCC-"};